<!-- 項目細項Box 主用於問卷 -->
<template>
  <div class="sub-box">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'sub-box',
  props: {
  }
}
</script>
<style lang="stylus" scoped>
.sub-box
  padding 10px 14px
  text-align justify
</style>
